import axios from "../../../utils/axios";

export const fetchAuthorizationURL = async (apiURL, requestDetails) => {
  return await axios.post(apiURL, { ...requestDetails });
};
